// Components
import StaticPagesHeader from "components/molecules/StaticPagesHeader";

// Hooks
import useTranslate from "hooks/useTranslate";

// Images
import GloryBackground from "assets/images/glory/error_page.webp";
import BangerBackground from "assets/images/banger/service_error_banger.webp";

import "./styles.sass";

const ErrorPage = () => {
  const t = useTranslate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  let backgroundImage;

  switch (VITE_APP_PROJECT_NAME) {
    case "glory":
      backgroundImage = GloryBackground;
      break;
    case "banger":
      backgroundImage = BangerBackground;
      break;
    default:
      backgroundImage = GloryBackground;
      break;
  }

  return (
    <div className="ErrorPage">
      <StaticPagesHeader />
      <div className="ErrorPage__content">
        <div className="ErrorPage__content_header">
          {t("error.title.maintenance")}
        </div>
        <img
          src={backgroundImage}
          alt="Not_available"
          className="ErrorPage__content_bg"
        />
        <div className="ErrorPage__content_text">
          {t("maintenance.description")}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
